import { createSelector } from '@lumapps/redux/reselect';
import { FrontOfficeStore } from '@lumapps/redux/types';

export const analyticsInfoSelector = (state: FrontOfficeStore) => state.analyticsInfo || {};

export const userDirectoriesCodeValuesSelector = createSelector(
    analyticsInfoSelector,
    (info) => info?.userDirCodeValues ?? [],
);
